/**
 * Plain-UUID QR labels (ADR-0003). The printer emits the canonical
 * `8-4-4-4-12` spelling; a scan is accepted case-insensitively and normalized
 * to lowercase before lookup/create, because container ids and mirrored item
 * barcodes are stored lowercase. `urn:uuid:`, brace-wrapped and URL-embedded
 * UUIDs are deliberately rejected — those are not labels.
 */

const LABEL_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Parse a scanned/typed payload as a plain-UUID label.
 *
 * @param payload the raw decode result or typed code.
 * @returns the lowercase canonical UUID, or null when the payload is not a
 *   plain-UUID label.
 */
export function parseLabelUuid(payload: string): string | null {
  const trimmed = payload.trim();
  return LABEL_UUID_RE.test(trimmed) ? trimmed.toLowerCase() : null;
}
